import React, { useEffect, useState } from "react";
import { PageHeader, Button, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { sliceKey, reducer, actions } from "./slice";
import { bookTestSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";
import SinglePageOrderForm from "../../../../forms/SinglePageOrderForm";
import schema from "../../../../schemas/singlePageOrderSchema";
import { useAuth } from "../../../../contexts/auth";

const BookTest = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: bookTestSaga });
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useAuth();
  const user = auth.loggedInUser;
  const isCompanyAdmin = auth.isCompanyAdmin;

  useEffect(() => {
    if (!isCompanyAdmin) {
      dispatch(actions.fetchCompanies());
    }
  }, [dispatch, isCompanyAdmin]);

  const companies = useSelector(selectors.selectCompanies) || [];
  const commodities = useSelector(selectors.selectCommodities);
  //const catalog = useSelector(selectors.selectCatalog);
  //const testCategories = useSelector(selectors.selectTestCategories);
  const tests = useSelector(selectors.selectTests);
  const users = useSelector(selectors.selectUsers);
  const { billingAddress, pickupAddress } = useSelector(
    selectors.selectUserAddress
  );

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);

  const [commoditySelected, setCommoditySelected] = useState(null);

  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Booking Order",
        description: error,
      });
    }
    setTimeout(() => {
      dispatch(actions.initializeError());
    }, 1500);
  }, [error, dispatch]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      company: isCompanyAdmin ? user.company._id : "",
      user: "",
      packages: [{ name: "", tests: [], notes: "", sampleCount: "" }],
      pickupRequestDate: "",
      pickupAddress: "",
      billingAddress: "",
    },
  });

  const selectedCopmany = watch("company");
  const selectedUser = watch("user");

  const getTestCategories = (index) => {
    const selectedCommodity = watch(`packages.${index}.commodity`);
    if (selectedCommodity) {
      setCommoditySelected(selectedCommodity);
      
      if (tests.length) {
        const testCategories = [];

        tests.forEach((test) => {
          const children = test.options.map((child) => {
            let obj = {
              title: (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p>{child.label}</p>
                  <p>₹{child.price}</p>
                </div>
              ),
              key: child.value,
              value: child.value,
            };

            return obj;
          });
          testCategories.push({
            title: test.label,
            key: test.value,
            value: test.value,
            children: children,
          });
        });

        return testCategories;
      }
    }
    /*const testCategories = [];
    const selectedCategories = [];
    catalog.forEach((item) => {
      const test = item.test;
      const testCategory = test.testCategory;
      const commodity = test.commodity;
      if (commodity._id === selectedCommodity) {
        const selectedCatIndex = selectedCategories.indexOf(testCategory._id);
        if (selectedCatIndex === -1) {
          selectedCategories.push(testCategory._id);
          testCategories.push({
            title: testCategory.name,
            key: testCategory._id,
            value: testCategory._id,
            children: [
              {
                title: (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{test.parameter}</p>
                    <p>₹{item.price}</p>
                  </div>
                ),
                key: test._id,
                value: item._id,
              },
            ],
          });
        } else {
          // add test to children
          const testIndex = testCategories[selectedCatIndex].children.findIndex(
            (item) => item.key === test._id
          );
          if (testIndex === -1) {
            testCategories[selectedCatIndex].children.push({
              title: (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p>{test.parameter}</p>
                  <p>₹{item.price}</p>
                </div>
              ),
              key: test._id,
              value: item._id,
            });
          }
        }
      }
    });

    return testCategories;
  */
  };
  useEffect(() => {
    return () => {
      dispatch(actions.initializeState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (selectedCopmany) {
      //dispatch(actions.fetchCatalog({ id: selectedCopmany }));
      dispatch(actions.fetchCompanyUsers({ id: selectedCopmany }));
      dispatch(actions.fetchCommodities({ companyId: selectedCopmany }));
    }
    setValue("user", "");
    setValue("packages", [{ name: "", tests: [], notes: "", sampleCount: "" }]);

  }, [dispatch, selectedCopmany, setValue]);

  useEffect(() => {
    if (selectedUser) {
      dispatch(actions.fetchUser({ id: selectedUser }));
    }
  }, [dispatch, selectedUser, setValue]);

  useEffect(() => {
    if (commoditySelected) {
      dispatch(
        actions.fetchTests({
          companyId: selectedCopmany,
          commodityId: commoditySelected,
        })
      );
    }
  }, [dispatch, commoditySelected, selectedCopmany]);

  const handleSuccess = () => {
    notification.success({
      message: "Order got booked",
    });
    history.push(routes.backOffice.orders.list);
  };

  const handleFailure = () => {
    /*  notification.error({
      message: "Failed to create order",
      description:
        "An error occured while creating the order. Please try again after some time.",
    }); */
  };

  const onSubmit = (data) => {
    const payload = {
      onSuccess: handleSuccess,
      data,
      onFailure: handleFailure,
    };
    dispatch(actions.createOrder(payload));
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Book Test"
        extra={[
          <Button
            key="create"
            type="primary"
            loading={loading}
            disabled={loading}
            onClick={handleSubmit(onSubmit)}
          >
            Place Order
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <SinglePageOrderForm
          isCompanyAdmin={isCompanyAdmin}
          control={control}
          watch={watch}
          errors={errors}
          setValue={setValue}
          options={{
            companies,
            commodities,
            users,
            billingAddress,
            pickupAddress,
          }}
          getTestCategories={getTestCategories}
        />
      </div>
    </div>
  );
};

export default BookTest;
